import React from 'react';
import { ABSENCE_CALENDAR_LEGEND } from '../utils/laborAbsenceCalendar';

export const LaborAbsenceLegend = () => (
  <div className="labor-fc-absence-legend" aria-label="Leyenda de ausencias">
    <span className="text-xs text-gray-400 mr-1">Ausencias:</span>
    {ABSENCE_CALENDAR_LEGEND.map(({ type, label, backgroundColor, borderColor }) => (
      <span key={type} className="labor-fc-absence-legend-item">
        <span
          className="labor-fc-absence-legend-swatch"
          style={{ backgroundColor, borderColor }}
          aria-hidden
        />
        {label}
      </span>
    ))}
  </div>
);
